export interface Datosgenerales {
    deviceConnected: number
    expiredDevices: number
    messagesAllDevice: number
    userRegister?: number
}

export const inizializarDatosGenarales: Datosgenerales = {
    deviceConnected: 0,
    expiredDevices: 0,
    messagesAllDevice: 0,
    userRegister: 0
}
